import { render, staticRenderFns } from "./PostAuthor.vue?vue&type=template&id=e065cb3a&"
import script from "./PostAuthor.vue?vue&type=script&lang=js&"
export * from "./PostAuthor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports